<template>
  <ul
    v-if="errors.length"
    class="cordel-errors"
  >
    <li
      v-for="error in items"
      :key="error"
    >
      {{ error }}
    </li>
  </ul>
</template>

<script>
  export default {
    name: 'CordelErrors',
    props: {
      errors: {
        type: Array,
        default() {
          return [];
        },
      },
    },
    computed: {
      items() {
        return this.errors.slice(0, 1);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';

  .cordel-errors {
    color: var(--cordel-legacy-color-alert-danger);
    list-style: none;
    margin-top: var(--cordel-legacy-spacing-micro);
  }
</style>
